import { render, staticRenderFns } from "./SynchronousScrolling.vue?vue&type=template&id=cc393ef6&scoped=true"
import script from "./SynchronousScrolling.vue?vue&type=script&lang=js"
export * from "./SynchronousScrolling.vue?vue&type=script&lang=js"
import style0 from "./SynchronousScrolling.vue?vue&type=style&index=0&id=cc393ef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc393ef6",
  null
  
)

export default component.exports